import { render } from "./MenuIcon.vue?vue&type=template&id=7eda73bf&scoped=true&ts=true"
import script from "./MenuIcon.vue?vue&type=script&lang=ts"
export * from "./MenuIcon.vue?vue&type=script&lang=ts"

import "./MenuIcon.vue?vue&type=style&index=0&id=7eda73bf&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eda73bf"]])

export default __exports__